<template>
  <div class="header">
    <h1 class="subtitle has-text-centered">
      <go-to-dashboard />
      &nbsp;
      {{ `${storeBeingManaged.storeInfo.name}` }}
    </h1>
    <hr />
  </div>
</template>

<script>
import goToDashboard from "../common/GoToDashboardButton";

export default {
  props: ["storeBeingManaged"],

  components: {
    goToDashboard
  }
};
</script>

<style scoped>
.header {
  position: sticky;
}
hr {
  background-color: hsl(0, 0%, 71%);
}
</style>
